import React, { useState, useEffect } from 'react';
import './Message.scss';

// Helper function to safely render HTML content
const createMarkup = (text) => {
    return { __html: text };
};

// Displays an individual message with fade-in animation and draggable functionality
const Message = ({ name, message, position, created_at, zIndex, style }) => {
    // State to control fade-in animation
    const [fadeIn, setFadeIn] = useState(false);
    // State to track hover status
    const [isHovered, setIsHovered] = useState(false);

    // Effect to trigger fade-in animation after component mounts
   /*  useEffect(() => {
        const timer = setTimeout(() => {
            setFadeIn(true); 
        }, 500);

        return () => clearTimeout(timer);
    }, []) */;

    // Formats a date string into DD.MM.YY format
    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = String(date.getFullYear()).slice(-2);
        return `${day}.${month}.${year}`;
    };

    return (
        <div
            className={`message draggable ${fadeIn ? 'fade-in' : ''}`} // Apply fade-in class when state is true
            style={{
                left: `${position.x}%`,
                top: `${position.y}%`,
                position: 'absolute',
                zIndex: isHovered ? 9999 : zIndex, // Increase z-index when hovered
                ...style // Spread additional style properties
            }}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
        >
            <p className='message-date'>{formatDate(created_at)} by {name}</p>
            <p
                className='message-text'
                dangerouslySetInnerHTML={createMarkup(message)}
            />
        </div>
    );
};

export default Message;